import React from 'react';
import { usePermissions } from '../Hooks/PermissionHooks';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';

interface ProtectedRouteProps {
  children: React.ReactNode;
  menuId?: string;
  requireAdmin?: boolean;
  feature?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  menuId, 
  requireAdmin = false,
  feature 
}) => {
  const { user, isAdmin, hasPermission } = usePermissions();

  // If user is not loaded yet, show loading
  if (!user) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    );
  }

  // Check if user is admin
  if (isAdmin()) {
    return <>{children}</>;
  }

  // Check if route requires admin
  if (requireAdmin) {
    return <AccessDenied />;
  }

  // Check menu permissions
  if (menuId && user.menuPermissions) {
    if (!user.menuPermissions.includes(menuId)) {
      return <AccessDenied />;
    }
  }

  // Check feature permissions
  if (feature && !hasPermission(feature)) {
    return <AccessDenied />;
  }

  // If no specific permissions required or all checks passed
  return <>{children}</>;
};

const AccessDenied = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={6}>
            <Card className="mt-5">
              <CardBody className="text-center p-5">
                <div className="mb-4">
                  <i className="ri-lock-2-line display-1 text-danger"></i>
                </div>
                <h3 className="mb-3">Zugriff verweigert</h3>
                <p className="text-muted mb-4">
                  Sie haben keine Berechtigung, auf diese Seite zuzugreifen.
                </p>
                <Button 
                  color="primary" 
                  onClick={() => window.history.back()}
                >
                  <i className="ri-arrow-left-line me-1"></i>
                  Zurück
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProtectedRoute;